<router-outlet></router-outlet>

<app-toast></app-toast>
<app-modal-outlet></app-modal-outlet>
<app-options></app-options>
<ng-question></ng-question>
